import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const Modal = ({ isOpen, onClose, title, children }) => {
  if (!isOpen) return null;
  return (
    <AnimatePresence>
      <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
        {/* Backdrop */}
        <motion.div 
          initial={{ opacity: 0 }} 
          animate={{ opacity: 1 }} 
          exit={{ opacity: 0 }} 
          onClick={onClose} 
          className="fixed inset-0 bg-black/40 backdrop-blur-sm" 
        />
        
        {/* Content */}
        <motion.div 
          initial={{ opacity: 0, scale: 0.95, y: 20 }} 
          animate={{ opacity: 1, scale: 1, y: 0 }} 
          exit={{ opacity: 0, scale: 0.95, y: 20 }} 
          className="relative w-full max-w-2xl max-h-[90vh] bg-white shadow-2xl rounded-sm overflow-hidden flex flex-col"
        >
          <div className="flex justify-between items-center px-8 py-6 border-b border-gray-50">
            <h2 className="text-xl font-light tracking-widest text-gray-800 uppercase text-xs">{title}</h2>
            <button 
              onClick={onClose} 
              className="flex items-center space-x-2 text-gray-400 hover:text-gray-900 transition-all group"
            >
              <span className="text-[10px] uppercase tracking-widest opacity-0 group-hover:opacity-100 transition-opacity">Schließen</span>
              <span className="text-3xl font-light leading-none">&times;</span>
            </button>
          </div>
          
          <div className="overflow-y-auto p-8 md:p-12 scrollbar-thin scrollbar-thumb-gray-200">
            {children}
          </div>

          <div className="p-6 bg-gray-50/50 flex justify-center border-t border-gray-50">
            <button 
              onClick={onClose}
              className="px-10 py-3 bg-gray-900 text-white text-[10px] uppercase tracking-[0.3em] hover:bg-gray-700 transition-all"
            >
              Fenster Schließen
            </button>
          </div>
        </motion.div>
      </div>
    </AnimatePresence>
  );
};

export default Modal;